<template>
    <el-card class="card-container">
      <template #header>
        <div class="card-header">
          <span>Provide Feedback</span>
        </div>
      </template>
      <el-form
        :model="form"
        :rules="rules"
        ref="feedbackForm"
        label-position="top"
        v-loading="isSubmittingForm"
        element-loading-text="Submitting your feedback..."
      >
        <div class="section mb-2">
          <h6 class="mb-2">Personal Information</h6>
          <el-row :gutter="20" class="mt-3">
            <el-col :lg="12" :sm="24">
              <el-form-item label="First Name" prop="firstName">
                <el-input
                  @update:model-value="value => form.firstName = value"
                  :model-value="form.firstName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :sm="24">
              <el-form-item label="Last Name" prop="lastName">
                <el-input
                  @update:model-value="value => form.lastName = value"
                  :model-value="form.lastName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="mt-3">
            <el-col :lg="12" :sm="24">
              <el-form-item label="Email" prop="email">
                <el-input v-model="form.email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :sm="24">
              <el-form-item label="Device" prop="device">
      <el-select  @update:model-value="onDeviceTypeSelected" class="w-100"
                  :model-value="form.device" placeholder="Select a device">
        <el-option label="iPhone" value="iPhone"></el-option>
        <el-option label="Android Phone" value="Android Phone"></el-option>
        <el-option label="iPad" value="iPad"></el-option>
        <el-option label="Tablet" value="Tablet"></el-option>
      </el-select>
    </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="mt-3">
            <el-col :lg="12" :sm="24">
              <el-form-item label="App Version" prop="appVersion">
                <el-input
                  @update:model-value="value => form.appVersion = value"
                  :model-value="form.appVersion"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :sm="24">
              <el-form-item label="Build Version" prop="buildVersion">
                <el-input
                  @update:model-value="value => form.buildVersion = value"
                  :model-value="form.buildVersion"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="mt-3" v-if="iOSDeviceSelected">
            <el-col :lg="12" :sm="24">
                <el-form-item label="iOS Version" prop="iOSVersion">
                <el-input
                  @update:model-value="value => form.iOSVersion = value"
                  :model-value="form.iOSVersion"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </div>

        <div class="section mb-2">
          <h6 class="mb-3">General Experience</h6>
          <el-form-item
            label="On a scale of 1-10, how would you rate the app's overall user experience? (1 worst, 10 best)"
            prop="userExperienceRating"
          >
            <el-radio-group
              @update:model-value="value => form.userExperienceRating = value"
              :model-value="form.userExperienceRating"
            >
              <el-radio :value="n" v-for="n in 10" :key="n">{{ n }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="Could you easily navigate through the app on a scale of 1-10? (1 worst, 10 best)"
            prop="easeOfNavigationRating"
          >
            <el-radio-group
              @update:model-value="value => form.easeOfNavigationRating = value"
              :model-value="form.easeOfNavigationRating"
            >
              <el-radio :value="n" v-for="n in 10" :key="n">{{ n }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="I found the UI (User Interface) intuitive and user-friendly? (1 Strongly disagree, 10 Strongly agree)"
            prop="uiFriendlinessRating"
          >
            <el-radio-group
              @update:model-value="value => form.uiFriendlinessRating = value"
              :model-value="form.uiFriendlinessRating"
            >
              <el-radio :value="n" v-for="n in 10" :key="n">{{ n }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <div class="section mb-2">
          <h6 class="mb-3">Feature-Specific Feedback</h6>

          <el-form-item
            label="Exercise videos were easy to follow and understand (1 Strongly disagree, 10 Strongly agree)"
            prop="exerciseVideoClarityRating"
          >
            <el-radio-group
              @update:model-value="value => form.exerciseVideoClarityRating = value"
              :model-value="form.exerciseVideoClarityRating"
            >
              <el-radio :value="n" v-for="n in 10" :key="n">{{ n }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="Did you experience any bugs or glitches while accessing the exercise videos?"
            prop="exerciseVideoGlitches"
          >
            <el-radio-group @update:model-value="value => form.exerciseVideoGlitches = value"
              :model-value="form.exerciseVideoGlitches">
              <el-radio value="Yes">Yes</el-radio>
              <el-radio value="No">No</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="Were you able to easily find and select workout plans?"
            prop="foundWorkoutPlansEasily"
          >
            <el-radio-group @update:model-value="value => form.foundWorkoutPlansEasily = value"
              :model-value="form.foundWorkoutPlansEasily">
              <el-radio value="Yes">Yes</el-radio>
              <el-radio value="No">No</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="How would you rate creating personalized workout plans with therapist guidance? (1 worst, 10 best)"
            prop="personalizedWorkoutPlansRating"
          >
            <el-radio-group
              @update:model-value="value => form.personalizedWorkoutPlansRating = value"
              :model-value="form.personalizedWorkoutPlansRating"
            >
              <el-radio :value="n" v-for="n in 10" :key="n">{{ n }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="Was the appointment booking feature straightforward?"
            prop="appointmentBookingStraightforward"
          >
            <el-radio-group @update:model-value="value => form.appointmentBookingStraightforward = value"
              :model-value="form.appointmentBookingStraightforward">
              <el-radio value="Yes">Yes</el-radio>
              <el-radio value="No">No</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="Did you receive timely notifications from therapists?"
            prop="appointmentTimelyNotifications"
          >
            <el-radio-group @update:model-value="value => form.appointmentTimelyNotifications = value"
              :model-value="form.appointmentTimelyNotifications">
              <el-radio value="Yes">Yes</el-radio>
              <el-radio value="No">No</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="Were you able to understand and utilize the Texavie coins feature?"
            prop="understoodTexavieCoins"
          >
            <el-radio-group @update:model-value="value => form.understoodTexavieCoins = value"
              :model-value="form.understoodTexavieCoins">
              <el-radio value="Yes">Yes</el-radio>
              <el-radio value="No">No</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="How would you rate the incentives offered via Texavie coins? (1 worst, 10 best)"
            prop="texavieCoinsIncentivesRating"
          >
            <el-radio-group
              @update:model-value="value => form.texavieCoinsIncentivesRating = value"
              :model-value="form.texavieCoinsIncentivesRating"
            >
              <el-radio :value="n" v-for="n in 10" :key="n">{{ n }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <div class="section mb-2">
          <h6 class="mb-3">Technical Aspects</h6>
          <el-form-item
            label="Did the app respond quickly to your actions, or did you experience any lags?"
            prop="appRespondedQuickly"
          >
            <el-radio-group @update:model-value="value => form.appRespondedQuickly = value"
              :model-value="form.appRespondedQuickly">
              <el-radio value="Yes">Yes</el-radio>
              <el-radio value="No">No</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="Did you easily connect the app to Bluetooth devices?"
            prop="connectedToBluetooth"
          >
            <el-radio-group @update:model-value="value => form.connectedToBluetooth = value"
              :model-value="form.connectedToBluetooth">
              <el-radio value="Yes">Yes</el-radio>
              <el-radio value="No">No</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="Did you face any issues while uploading files to or from the app?"
            prop="fileUploadIssues"
          >
            <el-radio-group @update:model-value="value => form.fileUploadIssues = value"
              :model-value="form.fileUploadIssues">
              <el-radio value="Yes">Yes</el-radio>
              <el-radio value="No">No</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <div class="section mb-2">
          <h6 class="mb-3">Additional Feedback</h6>
          <el-form-item
            label="Please list any bugs or issues you encountered while using the app."
            prop="bugsEncountered"
          >
            <el-input
              type="textarea"
              @update:model-value="value => form.bugsEncountered = value"
              :model-value="form.bugsEncountered"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="What features did you like the most?"
            prop="likedFeatures"
          >
            <el-input
              type="textarea"
              @update:model-value="value => form.likedFeatures = value"
              :model-value="form.likedFeatures"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="What improvements or additional features would you suggest?"
            prop="suggestedImprovements"
          >
            <el-input
              type="textarea"
              @update:model-value="value => form.suggestedImprovements = value"
              :model-value="form.suggestedImprovements"
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item label="Screenshots">
          <el-upload
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            v-model:file-list="uploadedFiles"
            accept="image/png, image/jpeg"
            :multiple="true"
          >
            <el-icon><Plus /></el-icon>

            <template #file="{ file }">
              <div>
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt=""
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview white-text"
                    @click="handlePictureCardPreview(file)"
                  >
                    <el-icon><zoom-in /></el-icon>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <el-icon><Delete /></el-icon>
                  </span>
                </span>
              </div>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button :loading="isSubmittingForm" @click="submitForm">Submit Feedback</el-button>
        </el-form-item>

        <el-alert
      class="mb-4 mt-2"
        v-if="dbError"
        :title="dbError"
        type="error"
        show-icon
        :closable="true"
      />
      <el-alert
      class="mb-4 mt-2"
        v-if="uploadError"
        :title="uploadError"
        type="error"
        show-icon
        :closable="true"
      />
      <el-alert
        class="mb-4 mt-2"
        v-if="formSubmitted"
        title="Thank You for Your Feedback!"
        type="success"
        show-icon
        :closable="true"
      />
      </el-form>

      <el-dialog
        :loading="isSubmittingForm"
        :model-value="dialogVisible"
        class="preview-dialog"
        @close="dialogVisible = false"
      >
        <img :src="dialogImageUrl" alt="Preview Image" class="preview-image" />
      </el-dialog>
    </el-card>
  </template>

<script>
import { xray } from '../../config/pluginInit'
import { ref, computed } from 'vue'
import useCollection from '../../services/useCollection'
import useStorage from '../../services/useStorage'
import firebase from '../../../firebase'
import { format } from 'date-fns'
import { Timestamp } from 'firebase/firestore'

export default {
  name: 'ReportBugs',
  mounted () {
    xray.index()
  },
  setup () {
    const dialogImageUrl = ref('')
    const dialogVisible = ref(false)
    const uploadedFiles = ref([])
    const currentUser = firebase.firebaseAuth.currentUser
    const { addDocToDb, dbError } = useCollection('feedbackReports')
    const { uploadImageFile, uploadError } = useStorage()
    const isSubmittingForm = ref(false)
    const formSubmitted = ref(false)
    const feedbackForm = ref(null)
    const iOSDeviceSelected = ref(false)

    const onDeviceTypeSelected = (value) => {
      form.value.device = value
      if (value === 'iPhone' || value === 'iPad') {
        iOSDeviceSelected.value = true
        rules.value.iOSVersion = [{ required: true, message: 'Please enter the iOS version', trigger: 'blur' }]
      } else {
        iOSDeviceSelected.value = false
        rules.value.iOSVersion = {}
      }
    }

    const handleRemove = (file) => {
      const index = uploadedFiles.value.findIndex(f => f.uid === file.uid)
      if (index !== -1) {
        uploadedFiles.value.splice(index, 1)
      }
    }

    const handlePictureCardPreview = (file) => {
      dialogImageUrl.value = file.url
      dialogVisible.value = true
    }

    const form = ref({
      firstName: currentUser.displayName ? currentUser.displayName.split(' ')[0] : '',
      lastName: currentUser.displayName && currentUser.displayName.split(' ').length > 1 ? currentUser.displayName.split(' ')[1] : '',
      email: currentUser.email,
      device: '',
      iOSVersion: '',
      appVersion: '',
      buildVersion: '',
      userExperienceRating: '',
      easeOfNavigationRating: '',
      uiFriendlinessRating: '',
      exerciseVideoClarityRating: '',
      exerciseVideoGlitches: '',
      foundWorkoutPlansEasily: '',
      personalizedWorkoutPlansRating: '',
      appointmentBookingStraightforward: '',
      appointmentTimelyNotifications: '',
      understoodTexavieCoins: '',
      texavieCoinsIncentivesRating: '',
      appRespondedQuickly: '',
      connectedToBluetooth: '',
      fileUploadIssues: '',
      bugsEncountered: '',
      likedFeatures: '',
      suggestedImprovements: ''
    })

    const generateRules = (formFields) => {
      const rules = {}
      Object.keys(formFields).forEach((field) => {
        rules[field] = [
          { required: true, message: `Please enter ${field.replace(/([A-Z])/g, ' $1').trim()}`, trigger: 'blur' }
        ]
      })
      rules.email.push({ type: 'email', message: 'Please enter a valid email', trigger: 'blur' })
      rules.bugsEncountered = {}
      rules.likedFeatures = {}
      rules.suggestedImprovements = {}
      rules.iOSVersion = {}
      return rules
    }

    const rules = computed(() => generateRules(form.value))

    const submitForm = () => {
      feedbackForm.value.validate(async (valid) => {
        if (valid) {
          isSubmittingForm.value = true
          formSubmitted.value = false
          try {
            const promises = uploadedFiles.value.map(async (file, index) => {
              // Generate a unique file name: userID_timestamp_index
              const timestamp = format(new Date(), 'yyyyMMddHHmmss')
              const userId = currentUser.uid
              const filename = `${userId}_${timestamp}_${index}`

              const url = await uploadImageFile(file.raw, `feedbackReports/${filename}`)
              return url
            })

            const screenshots = await Promise.all(promises)

            const reportData = {
              ...form.value,
              screenshots
            }
            reportData.createdAt = Timestamp.now()

            await addDocToDb(reportData)
            // Reset the form and uploaded files list after submission
            feedbackForm.value.resetFields()
            uploadedFiles.value = []
            formSubmitted.value = true
          } catch (error) {
            console.error('Error submitting bug report:', error)
          } finally {
            isSubmittingForm.value = false
          }
        }
      })
    }

    return {
      form,
      rules,
      feedbackForm,
      dialogImageUrl,
      dialogVisible,
      handleRemove,
      handlePictureCardPreview,
      uploadedFiles,
      submitForm,
      isSubmittingForm,
      dbError,
      uploadError,
      formSubmitted,
      onDeviceTypeSelected,
      iOSDeviceSelected
    }
  }
}
</script>

  <style scoped>
  .card-container {
    margin: 0 20px 20px 20px;
  }

  .card-header {
    background: transparent;
    border-bottom: none;
  }

  .card-header span {
    font-size: 16px;
    font-weight: 500;
    color: var(--text-color) !important;
  }

  .preview-image {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  h6 {
    color: #606266;
    font-weight: bold;
    text-transform: uppercase;
  }
  </style>
